import React from 'react';
import { motion } from 'framer-motion';

const Projects = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="space-y-6"
    >
      <div>
        <h1 className="text-3xl font-bold text-gray-800 mb-2">Projects</h1>
        <p className="text-gray-600">Manage your client projects and track progress</p>
      </div>
      
      <div className="bg-white rounded-xl p-8 shadow-soft text-center">
        <h3 className="text-lg font-semibold text-gray-800 mb-2">Projects Management</h3>
        <p className="text-gray-600">Project management features will be implemented here</p>
      </div>
    </motion.div>
  );
};

export default Projects;